import type { IConfigurationRepository } from '../repositories/IConfigurationRepository.js';

export function createListConfigurationsUseCase({ configurationRepository }: { configurationRepository: IConfigurationRepository }) {
  return (orgId: string, projectId?: string | null) => configurationRepository.list(orgId, projectId);
}
